import 'date-input-polyfill-react'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import InputMask from 'react-input-mask'
import { useEffect, useState } from 'react'
import moment from 'moment'

import styles from './Datepicker.module.sass'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATETIME_FORMAT = 'DD/MM/YYYY, HH:mm'

const Datepicker = (props) => {
	const {
		tint,
		type,
		onChange,
		className,
		text,
		subText,
		showFormat = true,
		layout = 'horizontal',
		initialDate,
		placeholder,
		...attributes
	} = props
	const [date, setDate] = useState(initialDate || moment())
	const isDate = type === 'date'
	const format = isDate ? DATE_FORMAT : DATETIME_FORMAT

	const [dateStr, setDateStr] = useState(null)

	const value = isDate
		? date.format('YYYY-MM-DD')
		: date.format('YYYY-MM-DDTHH:mm')

	const inputMask = isDate ? '99/99/9999' : '99/99/9999, 99:99'

	useEffect(() => {
		setDateStr(initialDate?.isValid?.() ? initialDate.format(format) : '')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<HStack
			{...attributes}
			className={`${styles['date-input']} ${className || ''} ${
				tint ? styles[`tint-${tint}`] : ''
			}`}
			columns={[1, '30px']}
			flex={[[1, 1]]}
		>
			<label className={styles[`${layout}-layout`]}>
				{subText ? (
					<VStack className={styles['--show-sub-text']}>
						<small>
							<strong>{text}</strong>
						</small>
						<small>{subText}</small>
					</VStack>
				) : (
					<small
						className={
							showFormat ? `${styles['--show-format']}` : ''
						}
					>
						<strong>{text}</strong> {showFormat && `(${format})`}
					</small>
				)}
				<InputMask
					mask={inputMask}
					value={dateStr}
					onChange={(e) => {
						const mDate = moment(e.target.value, format, true)
						setDateStr(e.target.value)
						onChange && onChange(mDate, mDate)
					}}
				>
					{(inputProps) => {
						return (
							<TextInput
								{...inputProps}
								tint={tint}
								name='date'
								placeholder={placeholder}
								type='text'
								ignoreInnerValue={true}
							/>
						)
					}}
				</InputMask>
			</label>

			<label>
				<Icon
					className={styles['icon']}
					name='calendar'
					width='24px'
					height='24px'
				/>
				<input
					tabIndex='-1'
					type={type}
					value={value}
					onFocus={(e) => {
						e.target.blur()
					}}
					onKeyDown={(e) => {
						e.preventDefault()
						e.target.blur()
					}}
					onChange={(e) => {
						const mDate = moment(e.target.value)
						if (mDate.isValid()) {
							setDate(mDate)
							setDateStr(() => mDate.format(format))
							onChange && onChange(mDate, mDate)
						} else {
							setDateStr('')
							onChange && onChange(date, mDate)
						}
					}}
				/>
			</label>
		</HStack>
	)
}

export default Datepicker
